import React, { useEffect } from "react";
import FooterLinksConteiner from "./FooterLinksConteiner.js";
import FormDetailsComponent from "./FormDetailsComponent.js";
import ButtonSettings from "./ButtonSettings.js";
import FormBuilderEditFieldContainer from "../NewFormBuilder/FormBuilderEditFields/FormBuilderEditFieldContainer.js";

// Right sidebar with field settings
const DetailsContainer = ({
  setFormDescription,
  formDisplayTitle,
  setFormDisplayTitle,
  formDescription,
  detailsMode,
  EmbedDynamicId,
  linkFooters,
  setLinkFooters,
  editCustomFooterLinks,
  setEditCustomFooterLinks,
  displayFooterLinks,
  setDisplayFooterLinks,
  formImage,
  setFormImage,
  showImage,
  setShowImage,
  showDescription,
  setShowDescription,
  showTitle,
  setShowTitle,
  invalidDescription,
  setInvalidDescription,
  invalidTitleForm,
  setInvalidTitleForm,
  updateBeforeSave,
  setUpdateBeforeSave,
  footerAbout,
  footerSupport,
  footerTerms,
  formButtonsColor,
  setFormButtonsColor,
  formButtonTextColor,
  setFormButtonTextColor,
  formItems,
  setFormItems,
  fieldSelected,
  formJson,
  setFormJson,
  formLanguage,
  errorTitleText,
  setErrorTitleText,
  setFormHeight,
}) => {
  const renderDetails = () => {
    switch (detailsMode) {
      case "form-details":
        return (
          <>
            <FormDetailsComponent
              setFormDisplayTitle={setFormDisplayTitle}
              formDisplayTitle={formDisplayTitle}
              setFormDescription={setFormDescription}
              formDescription={formDescription}
              EmbedDynamicId={EmbedDynamicId}
              setFormImage={setFormImage}
              formImage={formImage}
              showImage={showImage}
              setShowImage={setShowImage}
              showDescription={showDescription}
              setShowDescription={setShowDescription}
              showTitle={showTitle}
              setShowTitle={setShowTitle}
              invalidDescription={invalidDescription}
              setInvalidDescription={setInvalidDescription}
              invalidTitleForm={invalidTitleForm}
              setInvalidTitleForm={setInvalidTitleForm}
              updateBeforeSave={updateBeforeSave}
              setUpdateBeforeSave={setUpdateBeforeSave}
              errorTitleText={errorTitleText}
              setErrorTitleText={setErrorTitleText}
            />
          </>
        );
      case "footer-links":
        return (
          <FooterLinksConteiner
            linkFooters={linkFooters}
            setLinkFooters={setLinkFooters}
            editCustomFooterLinks={editCustomFooterLinks}
            setEditCustomFooterLinks={setEditCustomFooterLinks}
            displayFooterLinks={displayFooterLinks}
            setDisplayFooterLinks={setDisplayFooterLinks}
            footerAbout={footerAbout}
            footerSupport={footerSupport}
            footerTerms={footerTerms}
            setUpdateBeforeSave={setUpdateBeforeSave}
          />
        );
      case "button-settings":
        return (
          <ButtonSettings
            formButtonsColor={formButtonsColor}
            setFormButtonsColor={setFormButtonsColor}
            formButtonTextColor={formButtonTextColor}
            setFormButtonTextColor={setFormButtonTextColor}
            setUpdateBeforeSave={setUpdateBeforeSave}
          />
        );
      case "edit-field":
        return (
          <FormBuilderEditFieldContainer
            formItems={formItems}
            setFormItems={setFormItems}
            field={fieldSelected}
            formJson={formJson}
            setFormJson={setFormJson}
            setUpdateBeforeSave={setUpdateBeforeSave}
            formLanguage={formLanguage}
            setFormHeight={setFormHeight}
          />
        );

      default:
        break;
    }
  };

  return (
    <div className={`content-details`}>
      <div className="content-details-container">{renderDetails()}</div>
    </div>
  );
};

export default DetailsContainer;
